import { DateTime } from 'luxon';

export const FORMAT_DATE_TIME = 'Y-m-d H:i:S';
export const FORMAT_DATE = 'Y-m-d';

export const LUXTON_FORMAT_DATE_TIME = 'yyyy-LL-dd HH:mm:ss';
export const LUXTON_FORMAT_DATE = 'yyyy-LL-dd';

export const LUXTON_FORMAT_DATE_TIME_FILENAME = 'yyyyLLddHHmmss';

export const getDateTimeForFilename = () =>
  DateTime.fromJSDate(new Date()).toFormat(LUXTON_FORMAT_DATE_TIME_FILENAME);

export const transformDateFormatFlatPickerToLuxton = flatPickerFormat =>
  flatPickerFormat
    .replace(/y+/g, 'yy')
    .replace(/Y+/g, 'yyyy')
    .replace(/m+/g, 'LL')
    .replace(/n+/g, 'L')
    .replace(/d+/g, 'dd')
    .replace(/j+/g, 'd')
    .replace(/H+/g, 'HH')
    .replace(/i+/g, 'mm')
    .replace(/S+/g, 'ss');



// WEBPACK FOOTER //
// ./src/helpers/date.js